module.exports = {"title":"<0>Adieu au vieux.</0><1>Allo au nouveau!</1>"}